import { live, LiveController, RubySymbol } from "@camertron/live-component";
import { celebrate } from "../celebrate";

type GameComponentProps = {
  puzzle_id: string
  definition: string
  state: string
  phase: RubySymbol
}

@live("Wordle::GameComponent")
export class GameComponent extends LiveController<GameComponentProps> {
  on_key(key: string) {
    this.render((component) => {
      component.call("on_key", {key});
    }).then(() => {
      if (key === "Enter") {
        this.update_attempt();
      }
    });
  }

  on_done_flipping() {
    switch (this.props.phase.value) {
      case "won":
      case "lost":
        this.finish();
        break;
    }
  }

  finish() {
    if (this.props.phase.value === "won") {
      celebrate();
    }

    this.render((component) => {
      component.props.phase.value = "finished"
    }).then(() => {
      this.update_attempt();
    });
  }

  private update_attempt() {
    const csrf_param = document.querySelector("meta[name='csrf-param']")?.getAttribute("content");
    const csrf_token = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");

    fetch(`/puzzles/${this.props.puzzle_id}/attempts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: 'include',
      body: JSON.stringify({
        [csrf_param!]: csrf_token!,
        attempt: {
          state: this.props.state,
          phase: this.props.phase.value
        }
      })
    });
  }
}
